(() => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    const setMenu = (open) => {
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mobileMenu.hidden = !open;
      body.classList.toggle('menu-open', open);

      if (open) {
        window.requestAnimationFrame(() => mobileMenu.querySelector('a')?.focus());
      } else if (mobileMenu.contains(document.activeElement)) {
        menuButton.focus();
      }
    };

    menuButton.addEventListener('click', () => {
      setMenu(menuButton.getAttribute('aria-expanded') !== 'true');
    });

    mobileMenu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenu(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') setMenu(false);
    });
  }

  const headerDropdowns = [...document.querySelectorAll('[data-header-dropdown]')];

  headerDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      headerDropdowns.forEach((otherDropdown) => {
        if (otherDropdown !== dropdown) otherDropdown.open = false;
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-header-dropdown]')) return;
    headerDropdowns.forEach((dropdown) => {
      dropdown.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    headerDropdowns.forEach((dropdown) => {
      if (!dropdown.open) return;
      dropdown.open = false;
      dropdown.querySelector('summary')?.focus();
    });
  });

  const backLink = document.querySelector('[data-back-link]');

  if (backLink) {
    backLink.addEventListener('click', (event) => {
      if (!document.referrer || window.history.length <= 1) return;

      try {
        const previousUrl = new URL(document.referrer);
        const currentUrl = new URL(window.location.href);
        if (previousUrl.origin !== currentUrl.origin || previousUrl.href === currentUrl.href) return;

        event.preventDefault();
        window.history.back();
      } catch (error) {
        // Keep the contextual fallback link when browser history is unavailable.
      }
    });
  }

  document.querySelectorAll('[data-accordion-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const price = form.querySelector('[data-product-price]');
    const button = form.querySelector('[data-add-to-cart]');
    if (!select) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
      }
    });
  });
})();
